export default "__VITE_ASSET__3Rs9X3uF__"